export default __webpack_public_path__ + "static/media/resources_white_icon.175e1b73.svg";